import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { connect } from "react-redux";
import { FiX } from "react-icons/fi";
import { addItemDetail, editItemDetail, selectItemDetail } from "../../actions";
import { getTotalWeightInUnit } from "../common/helpers";
import ItemDetailsFormFields from "./ItemDetailsFormFields";

const INITIAL_ITEM = {
  description: "",
  quantity: "",
  net_weight: "",
  weight_unit: "kg",
  value_amount: "",
  value_currency: "KES",
};

const INITIAL_ERRORS = {
  descriptionError: false,
  quantityError: false,
  quantityTypeError: false,
  net_weightError: false,
  net_weightTypeError: false,
  net_weightValueError: false,
  value_amountError: false,
  value_amountTypeError: false,
  value_currencyError: false,
};

const ItemDetailsForm = ({
  show,
  toggleForm,
  itemIdx,
  itemDetails,
  parcels,
  addItemDetail,
  editItemDetail,
  selectItemDetail,
}) => {
  const [item, setItem] = useState(INITIAL_ITEM);
  const [errors, setErrors] = useState(INITIAL_ERRORS);

  useEffect(() => {
    if (itemIdx !== -1 && itemDetails.items[itemIdx]) {
      setItem({ ...itemDetails.items[itemIdx] });
    } else {
      setItem(INITIAL_ITEM);
    }
    setErrors(INITIAL_ERRORS);
  }, [itemIdx, show]);

  const updateState = (field, value) => {
    setItem((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({
      ...prev,
      [`${field}Error`]: false,
      [`${field}TypeError`]: false,
      [`${field}ValueError`]: false,
    }));
  };

  const closeForm = async () => {
    await selectItemDetail(-1);
    toggleForm();
  };

  const requiredFieldsCheck = (itemToCheck, fieldsArr) => {
    let valid = true;
    const newErrors = {};
    fieldsArr.forEach((field) => {
      if (!itemToCheck[field] || itemToCheck[field] === "") {
        newErrors[`${field}Error`] = true;
        valid = false;
      }
    });
    if (!valid) setErrors((prev) => ({ ...prev, ...newErrors }));
    return valid;
  };

  const numberFieldsCheck = (itemToCheck, fieldsArr) => {
    let valid = true;
    const newErrors = {};
    fieldsArr.forEach((field) => {
      if (itemToCheck[field] && isNaN(itemToCheck[field])) {
        newErrors[`${field}TypeError`] = true;
        valid = false;
      }
    });
    if (!valid) setErrors((prev) => ({ ...prev, ...newErrors }));
    return valid;
  };

  const checkItemWeight = (quantity, itemWeight, parcelWeight) => {
    return quantity * itemWeight > parcelWeight;
  };

  const saveItem = () => {
    const validatedItem = { ...item };
    const requiredFields = [
      "description",
      "quantity",
      "net_weight",
      "value_amount",
    ];
    const numberFields = ["quantity", "net_weight", "value_amount"];

    let valid = requiredFieldsCheck(validatedItem, requiredFields);
    valid = numberFieldsCheck(validatedItem, numberFields) && valid;

    if (
      valid &&
      checkItemWeight(
        parseFloat(validatedItem.quantity),
        parseFloat(validatedItem.net_weight),
        parseFloat(getTotalWeightInUnit(parcels, validatedItem.weight_unit)),
      )
    ) {
      setErrors((prev) => ({ ...prev, net_weightValueError: true }));
      valid = false;
    }

    if (valid) {
      if (itemIdx !== -1) {
        editItemDetail(validatedItem, itemIdx);
      } else {
        addItemDetail(validatedItem);
      }
      closeForm();
    }
  };

  if (!show) return null;

  return (
    <div
      className={`modal d-flex justify-content-center justify-content-lg-start aligin-items-center show`}
    >
      <div onClick={closeForm} onKeyDown={() => {}} className="backdrop"></div>
      <Card className="modal-content settings-card customs-items d-block col-11 col-lg-7 m-auto">
        <div className="card-section head col-12 d-flex flex-row justify-content-between">
          <h5>Item Details</h5>
          <a className="d-flex" onClick={closeForm} onKeyDown={closeForm}>
            <FiX />
          </a>
        </div>
        <div className="customs-item-form col-12">
          <div className="form-content">
            <ItemDetailsFormFields
              item={item}
              onUpdate={updateState}
              errors={errors}
              hideValueCurrency
            />
          </div>
          <div className="col-12 p-0 d-flex">
            <p className="text-danger"></p>
            <button className="col-12 p-0 ml-auto" onClick={saveItem}>
              {itemIdx !== -1 ? "Save" : "Add"}
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

const mapStateToProps = ({ itemDetails, parcels }) => ({
  itemDetails,
  itemIdx: itemDetails.selectedItem,
  parcels,
});

export default connect(mapStateToProps, {
  addItemDetail,
  editItemDetail,
  selectItemDetail,
})(ItemDetailsForm);
